import { AnalyticsContext, ContextType } from '@carvana/eventable-clickstream';
import React, { PureComponent, useContext } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';
import { LoadableState } from '~/contracts/common';
import { logError } from '~/utilities/errorHandlers';
import SimulateSpinnerCrash from './SimulateSpinnerCrash';
import StaticVehicle from './StaticVehicle';

type OwnProps = {
  children: React.ReactNode;
  spinnerReady: LoadableState<boolean>;
  trackEvent: ContextType['trackEvent'];
};

type OwnState = {
  hasError: boolean;
};

class ErrorBoundary extends PureComponent<OwnProps, OwnState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err, info) {
    const { spinnerReady, trackEvent } = this.props;
    spinnerReady.setError(err);
    trackEvent('spinnerFailed', { error: err, info });
    logError(err, { location: 'Spinner Error Boundary', info });
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    return hasError ? <StaticVehicle isVisible /> : children;
  }
}

const SpinnerErrorBoundary = ({ children }) => {
  const { trackEvent } = useContext(AnalyticsContext);
  const { spinnerReady } = useContext(GlobalContext);

  return (
    <ErrorBoundary spinnerReady={spinnerReady} trackEvent={trackEvent}>
      {children}
      <SimulateSpinnerCrash />
    </ErrorBoundary>
  );
};

export default SpinnerErrorBoundary;
